jQuery(function () {
    
    jQuery(window).on("scroll", function () {
        var wScrollTop = jQuery(window).scrollTop();
        if (wScrollTop > 0) {
            jQuery('.main-outercon').addClass('fixed');
        } else {
            jQuery('.main-outercon').removeClass('fixed');
        }
    });
    
/*===============================================
	Menu
==================================================*/   
   jQuery( ".nav-trigger" ).click(function() {
      jQuery( this ).toggleClass( "highlight" );
      jQuery( 'body' ).toggleClass( "nav-visible" ); 
      jQuery( this ).parent().parent().toggleClass( "nav-active" );
    });
    
   jQuery( ".overlay-block" ).click(function() {
      jQuery(".nav-trigger.highlight").removeClass( "highlight" );
      jQuery( 'body' ).removeClass( "nav-visible" ); 
      jQuery(".menu-block.nav-active").removeClass( "nav-active" );
    });
    
    jQuery('.main-nav li').has('ul').addClass('hassub');
    
    
    
/*============================================
   offcanvas menu
============================================ */
    jQuery('.menu-btn').click(function(e) {
        e.preventDefault();
        jQuery(this).toggleClass('active');
        jQuery(this).prev().toggleClass('slidein');
        jQuery('body').toggleClass('menuopened');
        jQuery('.header-right').toggleClass('pushed');
    });

  

 
/*===============================================
   Shiftcontent
==================================================*/     
    shiftcontent();
    jQuery(window).on("debouncedresize", function( event ) {
        shiftcontent();
        
    });
    
    
    
    
    /*===============================================
        Slick  
     ==================================================*/
    if (jQuery.fn.slick) {
        jQuery('.banner-slider').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            autoplay: true,
            dots: false,
            infinite: true,
            speed: 800,
            autoplaySpeed: 3000,
            fade: false,
            cssEase: 'linear'
        });
        
        
        jQuery('.product-list ul').slick({
            arrows: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            cssEase: 'linear',
            autoplay: true,
            autoplaySpeed: 6000,
            speed: 600,
            draggable: true,
            dots: false,
            rows: 0,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
        });
        
    }
    
});
function shiftcontent() {
    if (jQuery(".mob-visible").is(":visible")) {  
        
      jQuery(".fullwidth-section").each(function (index) {
            jQuery(this).find('.right-grid-inner').insertAfter(jQuery(this).find('.left-grid.txt-div h2'));
        });  
        
    } else {  
        
        jQuery(".fullwidth-section").each(function (index) {
            jQuery(this).find('.left-grid.txt-div .right-grid-inner').appendTo(jQuery(this).find('.right-grid'));
            
        }); 
    }
}